import React from 'react';
import {ViewProps} from 'react-native';
import {Platform, StyleSheet, View, ViewStyle} from 'react-native';

type ContentViewProps = ViewProps & {
  parentStyle?: ViewStyle;
  contentTestID?: string;
};
const ContentView = ({style, parentStyle, children, contentTestID, ...rest}: ContentViewProps) => (
  <View testID="content-view-parent" {...rest} style={[styles.parent, parentStyle]}>
    <View testID={contentTestID ?? 'content-view-content'} style={[styles.content, style]}>
      {children}
    </View>
  </View>
);

export default ContentView;

/** Web content column: max width and side padding. `usePageBleed` (WebFooter/SiteFooter) reads them. */
export const CONTENT_COLUMN_MAX_WIDTH = 1320;
export const CONTENT_COLUMN_GUTTER = 16;

const styles = StyleSheet.create({
  parent: {
    ...Platform.select({
      native: {
        flex: 1,
        paddingVertical: 10,
      },
      web: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        paddingVertical: 10,
      },
    }),
  },
  content: {
    ...Platform.select({
      native: {
        flex: 1,
        paddingHorizontal: CONTENT_COLUMN_GUTTER,
      },
      web: {
        flex: 1,
        maxWidth: CONTENT_COLUMN_MAX_WIDTH,
        paddingHorizontal: CONTENT_COLUMN_GUTTER,
      },
    }),
  },
});
